export default {
      id: "phone-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#phone",
      toString: function () {
        return this.url;
      }
    }